import { r as registerInstance, h } from './index-d4808923.js';

const gravityIconIndividualCss = ":host{display:contents}";
const GravityIconSheetStyle0 = gravityIconIndividualCss;

const GravityIconSheet = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.color = 'dark';
        this.size = 'xx-small';
    }
    render() {
        return (h("internal-gravity-base-icon", { key: 'e77d957fca22c204ab8f6784cacd78219fcc2295', color: this.color, size: this.size }, h("svg", { key: 'ed45364c9d21d36869789ac435639712256c5de4', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("path", { key: '0f2ff1040b0ecedfaef4e92d5aa538727e29cc05', d: "M7.75 15a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v.5a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5V15Zm.5-4a.5.5 0 0 0-.5.5v.5a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 .5-.5v-.5a.5.5 0 0 0-.5-.5h-5Z", fill: "currentColor" }), h("path", { key: '3016760c658ccc732d8eadfc0de7a09c76aaedd0', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M17.75 18.5a.5.5 0 0 1-.5.5h-12a.5.5 0 0 1-.5-.5v-15a.5.5 0 0 1 .5-.5h7.91a.49.49 0 0 1 .36.15l4.08 4.07a.47.47 0 0 1 .15.35V18.5Zm-1.5-1V8h-3a.5.5 0 0 1-.5-.5v-3h-6.5v13h10Z", fill: "currentColor" }))));
    }
};
GravityIconSheet.style = GravityIconSheetStyle0;

export { GravityIconSheet as gravity_icon_sheet };

//# sourceMappingURL=gravity-icon-sheet.entry.js.map